<script setup>
import { computed } from 'vue';

import {
    formataMoedaReais,
    formataCpf,
    formataCnpj
} from '@kodatec/brasil-utils';

import LabelsContratoBolsaEventual from '@/modules/projeto/components/detalhesSolicitacao/LabelsContratoBolsaEventual.vue';

const props = defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})

const pessoafisica = import.meta.env.VITE_TIPO_PESSOA_FISICA;

const nomeBeneficiario = computed(() => {
    const dados = props.solicitacao.dados;
    
    return dados.pessoa_nome || dados.pessoa_fisica_nome || dados.membro_nome;
});

const detalheBeneficiario = computed(() => {
    const dados = props.solicitacao.dados;
    
    const isPessoaFisica = dados.tipo_pessoa == pessoafisica || dados.membro_cpf || dados.pessoa_fisica_cpf || props.solicitacao.cpf;
    if (isPessoaFisica) {
        const cpf = dados.pessoa_documento || dados.pessoa_fisica_cpf || dados.membro_cpf;
        return 'CPF: ' + formataCpf(cpf, false);
    } else {
        const cnpj = dados.pessoa_documento || dados.pessoa_juridica_cnpj;
        return 'CNPJ: ' + formataCnpj(cnpj, false);
    }
});
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Beneficiário" v-if="nomeBeneficiario" :conteudo="nomeBeneficiario" :detalhe="detalheBeneficiario" />

    <LabelDados titulo="Parcela/Total" v-if="props.solicitacao.dados.parcela && props.solicitacao.dados.quantidade_parcelas"
        :conteudo="`${props.solicitacao.dados.parcela}/${props.solicitacao.dados.quantidade_parcelas}`">
        <template #detalhe v-if="props.solicitacao.dados.parcela > props.solicitacao.dados.quantidade_parcelas">
            Existem parcelas parciais ou estornadas
        </template>
    </LabelDados>

    <LabelDados titulo="Valor" v-if="props.solicitacao.dados.valor"
        :conteudo="formataMoedaReais(props.solicitacao.dados.valor)"
        :detalhe="props.solicitacao.dados.is_parcial ? 'Valor Parcial' : ''" />

    <LabelDados v-if="props.solicitacao.dados.is_parcial" titulo="Justificativa para Pagamento Parcial"
        :conteudo="props.solicitacao.dados.justificativa || 'Não informada'" tamanho_div="col-12" />

    <LabelDados titulo="Quantidade" v-if="props.solicitacao.dados.qtd && props.solicitacao.dados.unidade_medida"
        :conteudo="`${props.solicitacao.dados.qtd} ${props.solicitacao.dados.unidade_medida}`" />

    <LabelsContratoBolsaEventual :dados="props.solicitacao.dados" />

    <LabelDados titulo="Justificativa" v-if="props.solicitacao.dados.justificativa && !props.solicitacao.dados.is_parcial" :conteudo="props.solicitacao.dados.justificativa || 'Não informada'"
        tamanho_div="col-12" />

    <LabelDados titulo="Descrição" v-if="props.solicitacao.dados.descricao"
        :conteudo="props.solicitacao.dados.descricao" tamanho_div="col-12" />

</template>